/* global __webpack_init_sharing__, __webpack_share_scopes__ */
import "@pionglobal/pionsharedui/styles.css";
import { Provider } from "react-redux";
import "./App.css";
import { store } from "./app/store";
import ShowErrorAlert from "./components/common/notifiers/ShowErrorAlert";
import Notifications from "./components/notification/Notifications";
import Routes from "./routes/index";
import { setupAxiosInterceptor } from "./utils/setupAxiosInterceptor";
function App() {
  setupAxiosInterceptor();
  return (
    <Provider store={store}>
      <Notifications />
      <ShowErrorAlert />
      <Routes />
    </Provider>
  );
}

export default App;
